import { forwardRef, useState } from 'react';

const Input = forwardRef(({
  label,
  error,
  helperText,
  fullWidth = false,
  className,
  value,
  onChange,
  min,
  max,
  style,
  ...props
}, ref) => {
  const { type, ...restProps } = props
  const [displayValue, setDisplayValue] = useState('');

  const handleChange = (value) => {
    if (!value) {
      setDisplayValue(value);
      return;
    }

    // Ubah koma jadi titik untuk parsing ke Number
    const normalizedValue = value.replace(',', '.');

    // Cek apakah ada desimal
    const hasDecimal = normalizedValue.includes('.');

    let formattedValue;

    if (hasDecimal) {
      const [integerPart, decimalPart] = normalizedValue.split('.');
      formattedValue =
        Number(integerPart).toLocaleString('id-ID') +
        ',' +
        decimalPart;
    } else {
      formattedValue = Number(normalizedValue).toLocaleString('id-ID');
    }

    setDisplayValue(formattedValue);
  };

  const preProcessingOnChange = (event) => {
    const rawValue = event.target.value;
    let cleanValue = rawValue;
    if (type === "number") {
      cleanValue = rawValue.replace(/[^0-9,]/g, '');

      // Cegah lebih dari satu koma
      const parts = cleanValue.split(',');
      if (parts.length > 2) {
        cleanValue = parts[0] + ',' + parts.slice(1).join('');
      }

      let number = parseFloat(cleanValue.replace(",", "."));
      if (!isNaN(number)) {
        if (min !== undefined && number < min) {
          cleanValue = String(min)
          number = cleanValue;
        } else if (max !== undefined && number > max) {
          cleanValue = String(max);
          number = cleanValue;
        }
      }

      handleChange(cleanValue);
      cleanValue = number;
    };


    onChange({
      ...event,
      target: {
        ...event.target,
        value: cleanValue, // Nilai yang diubah
        name: event.target.name
      }
    });
  }

  const containerStyle = {
    marginBottom: '1rem',
    width: fullWidth ? '100%' : 'auto'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '0.25rem'
  };

  const requiredStyle = {
    color: '#ef4444',
    marginLeft: '0.25rem'
  };

  const inputStyle = {
    display: 'block',
    width: '100%',
    padding: '0.5rem 0.75rem',
    border: `1px solid ${error ? '#ef4444' : '#d1d5db'}`,
    borderRadius: '0.5rem',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    outline: 'none',
    transition: 'all 0.2s',
    ...style
  };

  const errorTextStyle = {
    marginTop: '0.25rem',
    fontSize: '0.875rem',
    color: '#dc2626'
  };

  const helperTextStyle = {
    marginTop: '0.25rem',
    fontSize: '0.875rem',
    color: '#6b7280'
  };

  return (
    <div style={containerStyle}>
      {label && (
        <label style={labelStyle}>
          {label}
          {props.required && <span style={requiredStyle}>*</span>}
        </label>
      )}

      <input
        ref={ref}
        type={["text", "number"].includes(type) ? "text" : type}
        style={inputStyle}
        className={className}
        autoComplete={type === "number" ? "off" : "on"}
        value={type === "number" ? displayValue : value}
        onChange={preProcessingOnChange}
        {...restProps}
      />

      {error && (
        <p style={errorTextStyle}>{error}</p>
      )}

      {helperText && !error && (
        <p style={helperTextStyle}>{helperText}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;